module.exports = __webpack_public_path__ + "img/ab18733.jpg";